import { Rule } from '../../Rules'

const whyForkRules: Array<Rule> = [
  {
    details: 'A bug was introduced in the 2.0 version of XYO World that caused the contract to revert when attempting to mint Dutch Auctions.',
    reason:
      'The cause of this bug was the introduction of the minting reward.  In the case of a Dutch Auction, the contract attemted to transfer 0 XYO to address 0x0, which caused the contract to revent.',
    summary: 'Minting Dutch Action Geotokens did not work.',
  },
]

export default whyForkRules
